import { render } from "./index.vue?vue&type=template&id=e4918fa8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e4918fa8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e4918fa8"

export default script